import type { NextPage } from 'next';
import type { ReactElement, ReactNode } from 'react';
import type { Store } from 'redux';
import { HostSum } from '../components/HeadMeta';
import type { RootState } from '../store/types';
import type { ExtendedNextPageContext } from './with-apollo-client';

export type NextPageWithLayout<P = object> = NextPage<P> & {
  getLayout?: (page: ReactElement, pageProps: P) => ReactNode;
};

export type PageContextWithStore = ExtendedNextPageContext & {
  store: Store<RootState>;
};

export enum Language {
  ru = 'ru',
  az = 'az'
}

export interface SEOData {
  title?: string | null;
  description?: string | null;
  h1?: string | null;
  asPath: string | null;
  hostSum: HostSum | null;
}
